export default __webpack_public_path__ + "static/media/bg3.b54818bc.png";